/**
 * Product card color swatches swap the card's image in place.
 *
 * Swatches are plain <button type="button"> elements (see
 * snippets/card-product.liquid), not links, so there is no href for the
 * browser to navigate to and no click-cancellation trickery is needed -
 * this just updates the DOM.
 *
 * Uses a single delegated click listener on document, so it keeps
 * working for cards rendered later (AJAX sections, infinite scroll,
 * theme editor re-renders) with no extra wiring.
 */
(function () {
  if (window.__cardColorSwatchSwapInit) return;
  window.__cardColorSwatchSwapInit = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.js-color-swatch');
    if (!swatch) return;

    var scope = swatch.closest('[data-card-swatch-scope]');
    if (!scope) return;

    event.preventDefault();

    var imageUrl = swatch.getAttribute('data-swatch-image');
    if (imageUrl) {
      var img = scope.querySelector('.js-swatch-target-image');
      if (img) {
        img.setAttribute('src', imageUrl);
        img.removeAttribute('srcset');
        var altText = swatch.getAttribute('data-swatch-alt');
        if (altText) img.setAttribute('alt', altText);
      }
    }

    var colorName = swatch.getAttribute('data-swatch-color-name');
    if (colorName) {
      var colorNameEls = scope.querySelectorAll('.js-swatch-target-color-name');
      for (var i = 0; i < colorNameEls.length; i++) {
        colorNameEls[i].textContent = colorName;
      }
    }

    var swatchesInScope = scope.querySelectorAll('.js-color-swatch');
    for (var j = 0; j < swatchesInScope.length; j++) {
      swatchesInScope[j].classList.remove('is-active-swatch');
      swatchesInScope[j].setAttribute('aria-pressed', 'false');
    }
    swatch.classList.add('is-active-swatch');
    swatch.setAttribute('aria-pressed', 'true');
  });
})();
